module.exports = __webpack_public_path__ + "static/media/test_avatar.0d765517.png";